<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                        :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.employee') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.alreadyCheckin') }}</label>
                    <v-select class="" v-model="selectedIsCheckIn" :clearable="false" :options="isCheckInOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.late') }}</label>
                    <v-select class="" v-model="selectedIsLate" :clearable="false" :options="isLateOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.times') }}</label>
                    <div class="flex-grow">
                        <date-range-picker class="w-full" ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }"
                            :opens="'right'" @update="dateRangePicker" v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.workShift') }}</label>
                    <v-select v-model="workShiftModel" :options="workShiftOptions">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-8 items-center">
                    <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                        @input="updateSearchQuery" :placeholder="$t('button.search')" />
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-2">
                <vs-button class="mt-4 mr-4" @click="search" :disabled="!validateForm" iconPack="feather" icon="icon-search">{{ this.$t('button.search') }}
                </vs-button>
                <vs-button class="mt-4 mr-4" @click="exportFile" :disabled="!validateForm" iconPack="feather" icon="icon-download">
                    {{ this.$t('timeKeeping.createReport') }}</vs-button>
                <vs-button class="mt-4" iconPack="feather" icon="icon-download" :disabled="!validateForm" @click="generateReport">{{ $t('attendance.export') }}</vs-button>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="workShiftData"
                         :animateRows="true"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         paginationPageSize="20"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000"
                         :tooltipMouseTrack="true">
            </ag-grid-vue>


            <div class="vx-row" v-if="workShiftData.length > 0">
                <div class="w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold ml-4">Hiển thị: </span><span
                            class="text-page">{{ countElementPage > totalElements ? totalElements : countElementPage }} /
                            {{ totalElements }} </span>
                    </div>
                    <vs-pagination
                        :total="totalPages"
                        v-model="currentPage"
                        @change="loadPage"/>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import moment from 'moment'; // Vuesax
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        Pagination,
        CellRendererActions,
        DateRangePicker,
        flatPickr
    },
    data() {
        return {
            workShiftId: null,
            workShiftOptions: [
                { value: null, label: this.$t('menuOrganization.all') }
            ],
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('timeKeeping.employeeCode'),
                    field: 'employeeCode',
                    width: 100
                },
                {
                    headerName: this.$t('timeKeeping.fullName'),
                    field: 'fullName',
                    width: 200
                },
                {
                    headerName: this.$t('timeKeeping.shift'),
                    field: 'displayGroupName',
                    width: 200,
                    tooltipField: 'displayGroupName',
                },
                {
                    headerName: this.$t('timeKeeping.date'),
                    field: 'date',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.onShift'),
                    field: 'checkinTime',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.afterWork'),
                    field: 'checkoutTime',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.typeCheckin'),
                    field: 'actionTypeName',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            employeeData: [],
            workShiftData: [],
            organizationBranchOptions: [],
            employeeOptions: [
                { value: null, label: this.$t('menuOrganization.all') }
            ],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            isCheckIn: null,
            isCheckInOptions: [
                { value: null, label: this.$t('menuOrganization.all') },
                { value: true, label: 'Đã check in' },
                { value: false, label: 'Chưa check in' }
            ],
            isLate: null,
            isLateOptions: [
                { value: null, label: this.$t('menuOrganization.all') },
                { value: true, label: 'Đi muộn' }
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },
    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
        if (branchList.length == 0) {
            return this.$vs.notify({
                text: 'Hiện tại không tồn tại chi nhánh nào',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType !== 3).map(item => {
            return { value: item.id, label: item.organizationBranchName }
        })
        this.organizationBranchOptions.unshift({ value: null, label: "Tất cả" })
        if (this.$route.query.isCheckin && this.$route.query.isCheckin == 'true') {
            this.selectedIsCheckIn = { value: true, label: 'Đã check in' };
        } else if (this.$route.query.isCheckin && this.$route.query.isCheckin == 'false') {
            this.selectedIsCheckIn = { value: false, label: 'Chưa check in' };
        }
        if (this.$route.query.employeeId) this.selectedEmployeeValue = this.$route.query.employeeId;
        if (this.$route.query.isLate == 'false') {
            this.selectedIsLate = { value: true, label: 'Đi muộn' };
        }
        if (this.$route.query.theBestLate == 'false') {
            this.dateRange.startDate = new Date(new Date().setDate(new Date().getDate() - 1));
            this.dateRange.endDate = new Date(new Date().setDate(new Date().getDate() - 1));
        }
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateCheckInCheckOut'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', false);
            }
        }
    },
    computed: {
        workShiftModel: {
            get(){
                let object = this.workShiftOptions.find(el => el.value == this.workShiftId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workShiftId = object ? object.value : null;
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null
                await this.loadEmployee();
                await this.getTeachingSchedule();
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
        selectedIsCheckIn: {
            get() {
                return {
                    label: this.isCheckinString(this.isCheckIn),
                    value: this.isCheckIn
                }
            },
            set(obj) {
                this.isCheckIn = obj.value
            }
        },
        selectedIsLate: {
            get() {
                return {
                    label: this.isLateString(this.isLate),
                    value: this.isLate
                }
            },
            set(obj) {
                this.isLate = obj.value
            }
        }
    },
    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },

        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'xác định';
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value === id);
            return (employee && employee.label) || 'Chưa xác định';
        },
        isCheckinString(id) {
            let isCheckIn = this.isCheckInOptions.find(x => x.value === id);
            return (isCheckIn && isCheckIn.label) || 'Chưa xác định';
        },
        isLateString(id) {
            let isLate = this.isLateOptions.find(x => x.value === id);
            return (isLate && isLate.label) || 'Chưa xác định';
        },
        addEmployee() {
            this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        validateForm() {
            return !this.errors.any()
        },
        getTeachingSchedule(){
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                const payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    type: 0
                }
                this.$crm.post('/teaching-schedule/find-all', payload).then((res) => {
                    this.workShiftOptions = res.data.map(el => {
                        return {
                            label: el.name + " " + el.startTime + "-" + el.endTime,
                            value: el.id
                        }
                    });
                    this.workShiftOptions.unshift({label: 'Tất cả', value: null})
                    resolve()
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        filter() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate,
                isSchool: true,
                teachingScheduleId: this.workShiftId,
                faceType: "employee"
            }
            this.$vs.loading()
            this.$crm.post('/time-keeping/find', searchInfo).then((response) => {
                let workShiftData = response.data.sort((item1, item2) => {
                    if (moment(item1.date) < moment(item2.date)) return 1;
                    if (moment(item1.date) > moment(item2.date)) return -1;
                    return 0
                })
                this.workShiftData = workShiftData.map(item => {
                    let result = this.employeeData.find(x => x.employeeId == item.employeeId)
                    if (result) {
                        item.check = 1
                        item.endHour = Math.floor(item.endHour / 60) + ':' + (item.endHour % 60 > 9 ? item.endHour % 60 : '0' + item.endHour % 60)
                        item.startHour = Math.floor(item.startHour / 60) + ':' + (item.startHour % 60 > 9 ? item.startHour % 60 : '0' + item.startHour % 60)
                        item.displayGroupName = item.workShiftName + '  ' + item.startHour + '-' + item.endHour;
                        item.branchId = this.selectedOrganizationBranchValue;
                        item.actionTypeName = '';
                        if (item.actionType) {
                            switch (item.actionType) {
                                case 0:
                                    item.actionTypeName = 'CameraAI';
                                    break;
                                case 1:
                                    item.actionTypeName = 'Wifi';
                                    break;
                                case 2:
                                    item.actionTypeName = 'QR Code';
                                    break;
                                case 3:
                                    item.actionTypeName = 'Quản lý duyệt';
                                    break;
                                case 4:
                                    item.actionTypeName = 'Khiếu nại chấm công';
                                    break;
                                case 5:
                                    item.actionTypeName = 'Chấm công từ xa';
                                    break;
                                case 6:
                                    item.actionTypeName = 'Pad';
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    return item;
                })
                // this.workShiftData = this.workShiftData.filter(x => x.classIds.length === 0);
                this.workShiftData = this.workShiftData.filter(el => el.fullName);
                this.workShiftData.forEach(el => {
                    el.stt = 20 * (this.currentPage - 1) + this.workShiftData.indexOf(el) + 1;
                })
                this.countElementPage = this.currentPage * 20;
                this.totalElements = this.workShiftData.length;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        exportFile() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate,
                faceType: "employee"
            };

            this.$vs.loading();
            this.$crm.post('/time-keeping/create', searchInfo).then((response) => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },

        async initScreen() {

            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
                this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            }
            await this.loadEmployee();
            await this.getTeachingSchedule();
            this.filter();
        },
        loadEmployee() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    enabled: true,
                    departmentType : 0
                }
                this.$vs.loading();
                this.$crm.post('/employee/all', payload).then((response) => {
                    this.$vs.loading.close();
                    if (response.data && response.data.length > 0) {
                        this.employeeOptions = response.data.map(item => {
                            return {
                                value: item.employeeId,
                                label: item.employeeCode + "_" + item.fullName,
                                employeeCode: item.employeeCode
                            }
                        });
                        this.employeeData = response.data;
                    } else {
                        this.employeeOptions = [];
                        this.employeeData = [];
                    }
                    if (this.employeeOptions.length > 0 && this.selectedEmployeeValue) {
                        this.selectedEmployee = this.employeeOptions.find(x => x.value === this.selectedEmployeeValue);
                    }
                    this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                    resolve(response)
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        generateReport() {
            let data = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate,
                isSchool: true,
                teachingScheduleId: this.workShiftId,
                faceType: "employee"
            }

            this.$vs.loading()
            this.$crm.post(`/time-keeping/export?isEmployee=true`, data).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        search() {
            this.currentPage = 1;
            if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
            this.filter();
        }

    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>

